module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAwgAAAAMCAYAAADGfJqcAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAC9SURBVHgB7dy9CcJgEIDhM2QQdxQJ2KVMIegEOoIjOIoj2Fl9OYNEsPCn93ue6opb4IXjYrXeHLquWwYAAFC9xRQIOc/Htin9MAyXAAAAqvQaCE9CAQAAKvUuEJ6EAgAAVOZbIMwbeYoy7rfb4RwAAMBf+x0IAABALbIJAACAWftzI/McOfZOjAAA4P99DgRhAAAA1XkXCMfSlH7nexEAAFTnEQiZcV1k7ku57SbXAAAAqtTGmP0oDAAAgMkdFtlOHo+v0hIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/splitter.png
// module id = Ix7s
// module chunks = 1